export default __webpack_public_path__ + "static/media/announcement_speaker_audio_media_multimedia_icon.12094810.svg";